import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import FoodMenuFields from './FoodMenuFields'

export const FoodMenuCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar simpleSaveRefresh={true}/>} redirect="list">
      <Grid container spacing={8}>
        <FoodMenuFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default FoodMenuCreate
